<template>
  <div id="app">
    <el-container style="height: 100vh">
      <el-aside width="200px" style="background: #304156">
        <div class="logo" style="height: 60px; line-height: 60px; text-align: center; color: #fff; font-size: 18px; font-weight: bold;">
          停车管理系统
        </div>
        <el-menu
          :default-active="$route.path"
          router
          background-color="#304156"
          text-color="#bfcbd9"
          active-text-color="#409EFF"
        >
          <el-menu-item index="/">
            <i class="el-icon-office-building"></i>
            <span>停车场管理</span>
          </el-menu-item>
          <el-menu-item index="/vehicle">
            <i class="el-icon-truck"></i>
            <span>车辆管理</span>
          </el-menu-item>
          <el-menu-item index="/payment">
            <i class="el-icon-money"></i>
            <span>收费记录</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-container>
        <el-header style="background: #fff; box-shadow: 0 1px 4px rgba(0,21,41,.08)">
          <div style="line-height: 60px; font-size: 20px; font-weight: 500;">
            {{ pageTitle }}
          </div>
        </el-header>
        <el-main style="background: #f0f2f5">
          <router-view/>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  computed: {
    pageTitle() {
      const titles = {
        '/': '停车场管理',
        '/vehicle': '车辆管理',
        '/payment': '收费记录'
      }
      return titles[this.$route.path] || '停车管理系统'
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}
</style>
